var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t岗位支援-" + _vm._s(_vm.ruleForm.id === null || _vm.ruleForm.id === '' ? '新增' : '修改'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-top": "80px"
    },
    attrs: {
      "label": "支援项目",
      "prop": "organize_temporary_ids"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "collapse-tags": "",
      "props": _vm.props,
      "show-all-levels": false
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.ruleForm.organize_temporary_ids),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "organize_temporary_ids", $$v)
      },
      expression: "ruleForm.organize_temporary_ids"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    on: {
      "click": _vm.StaffFind
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "支援人",
      "prop": "support_staff"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.ruleForm.support_staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "support_staff_name", $$v)
      },
      expression: "ruleForm.support_staff_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "支援开始时间",
      "prop": "start_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.ruleForm.start_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "start_date", $$v)
      },
      expression: "ruleForm.start_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "支援结束时间",
      "prop": "end_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.ruleForm.end_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "end_date", $$v)
      },
      expression: "ruleForm.end_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "日工资",
      "prop": "daily_wage"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入日工资",
      "type": "number"
    },
    model: {
      value: (_vm.ruleForm.daily_wage),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "daily_wage", $$v)
      },
      expression: "ruleForm.daily_wage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "成本承担方",
      "prop": "cost_bearing_party"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.ruleForm.cost_bearing_party),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cost_bearing_party", $$v)
      },
      expression: "ruleForm.cost_bearing_party"
    }
  }, [_vm._v("对方项目承担")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.ruleForm.cost_bearing_party),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cost_bearing_party", $$v)
      },
      expression: "ruleForm.cost_bearing_party"
    }
  }, [_vm._v("本项目承担")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "操作人",
      "prop": "operator_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.ruleForm.operator_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "operator_name", $$v)
      },
      expression: "ruleForm.operator_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "操作时间",
      "prop": "operator_date"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.ruleForm.operator_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "operator_date", $$v)
      },
      expression: "ruleForm.operator_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "200px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Add('ruleForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Update('ruleForm')
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择支援人",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "checkbox",
      "accordion": true,
      "staff_ids_prop": _vm.object.staff_ids
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c90366e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Gwzygl/Gwzy/Gwzy_add.vue
// module id = null
// module chunks = 